const TYPE = `[WELLNESS]`;

const Types = {
    SAVE_MOOD_START: `${TYPE} SAVE MOOD START`,
    SAVE_MOOD_SUCCESS: `${TYPE} SAVE MOOD SUCCESS`,
    SAVE_MOOD_ERROR: `${TYPE} SAVE MOOD ERROR`,

    FETCH_MOOD_HISTORY_START: `${TYPE} FETCH MOOD HISTORY START`,
    FETCH_MOOD_HISTORY_SUCCESS: `${TYPE} FETCH MOOD HISTORY SUCCESS`,
    FETCH_MOOD_HISTORY_ERROR: `${TYPE} FETCH MOOD HISTORY ERROR`,

    SAVE_JOURNAL_START: `${TYPE} SAVE JOURNAL START`,
    SAVE_JOURNAL_SUCCESS: `${TYPE} SAVE JOURNAL SUCCESS`,
    SAVE_JOURNAL_ERROR: `${TYPE} SAVE JOURNAL ERROR`,

    FETCH_JOURNAL_START: `${TYPE} FETCH JOURNAL START`,
    FETCH_JOURNAL_SUCCESS: `${TYPE} FETCH JOURNAL SUCCESS`,
    FETCH_JOURNAL_ERROR: `${TYPE} FETCH JOURNAL ERROR`,

    LOG_SOS_START: `${TYPE} LOG SOS START`,
    LOG_SOS_SUCCESS: `${TYPE} LOG SOS SUCCESS`,
    LOG_SOS_ERROR: `${TYPE} LOG SOS ERROR`,

    SAVE_ACTIVITY_START: `${TYPE} SAVE ACTIVITY START`,
    SAVE_ACTIVITY_SUCCESS: `${TYPE} SAVE ACTIVITY SUCCESS`,
    SAVE_ACTIVITY_ERROR: `${TYPE} SAVE ACTIVITY ERROR`,

    FETCH_ALERTS_START: `${TYPE} FETCH ALERTS START`,
    FETCH_ALERTS_SUCCESS: `${TYPE} FETCH ALERTS SUCCESS`,
    FETCH_ALERTS_ERROR: `${TYPE} FETCH ALERTS ERROR`,

    FETCH_PATIENT_SUMMARY_START: `${TYPE} FETCH PATIENT SUMMARY START`,
    FETCH_PATIENT_SUMMARY_SUCCESS: `${TYPE} FETCH PATIENT SUMMARY SUCCESS`,
    FETCH_PATIENT_SUMMARY_ERROR: `${TYPE} FETCH PATIENT SUMMARY ERROR`,

    RESET_ERROR: `${TYPE} RESET ERROR`,
};

export default Types;
